import {Component, OnInit, ViewChild} from '@angular/core';
import {VehicleBrand} from '../../../domain/core/vehicle-brand.model';
import {LegalEntity} from '../../../domain/core/legal-entity.model';
import {ActivatedRoute, Router} from '@angular/router';
import {Country} from '../../../domain/core/country.model';
import {environment} from '../../../../environments/environment';
import {AppState} from '../../../shared/utils/AppState';
import {plainToInstance} from 'class-transformer';
import {WizardComponent} from '../wizard/wizard.component';
import {WizardType} from '../wizard/wizard-type.enum';
import {CustomerWizardResponse} from '../../../domain/data/customer-wizard-response.data';
import {DigitalSignatureRequest} from '../../../domain/data/digital-signature-request';
import {WizardService} from '../../../shared/services/wizard.service';
import {LoadingSpinnerComponent} from '../../../shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-digital-signature',
  imports: [
    WizardComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './digital-signature.component.html'
})
export class DigitalSignatureComponent implements OnInit {
  brand: VehicleBrand;
  legalEntity = LegalEntity.ToyotaGermany;
  tecCustomerId: string;
  dealerId: string;
  interactionToken: string;
  favIcon: HTMLLinkElement = document.querySelector('#favIcon');
  customerWizardResponse: CustomerWizardResponse;
  digitalSignatureRequest: DigitalSignatureRequest;
  sendSummaryMail = false;
  signatures: { [step: number]: string } = {};

  loadingData = false;

  @ViewChild(WizardComponent) wizardComponent: WizardComponent;

  protected readonly WizardType = WizardType;

  constructor(
    private wizardService: WizardService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadingData = true;
    this.route.params.subscribe(params => {
      this.setBrand(params['brand']);
      this.tecCustomerId = params['tecCustomerId'];
      this.dealerId = params['dealerId'];
      this.interactionToken = params['interactionToken'];

      this.wizardService
        .getCustomerDigSigWizardData(
          this.brand.name.toLowerCase(),
          this.tecCustomerId,
          this.dealerId,
          this.interactionToken)
        .subscribe({
          next: response => {
            this.customerWizardResponse = plainToInstance(CustomerWizardResponse, response);
            this.loadingData = false;
          },
          error: error => {
            console.log('error by wizard data', error);
            this.redirectToErrorPage();
          }
        });
    });
    this.digitalSignatureRequest = new DigitalSignatureRequest();
  }

  setBrand(brand: string) {
    this.brand = new VehicleBrand(brand);
    this.legalEntity = LegalEntity.from(VehicleBrand.from(brand), Country.from(environment.country))
    AppState.shared.setLegalEntity(this.legalEntity)
    this.favIcon.href = '/assets/images/' + this.brand.favicon;
  }

  redirectToErrorPage() {
    this.router.navigate(['error']);
  }

  onStepAccepted(event: { step: number, signature: string }) {
    this.signatures[event.step] = event.signature;
    switch (event.step) {
      case 1:
        this.digitalSignatureRequest.communicationSignature = event.signature;
        this.wizardComponent.nextStep();
        break;
      case 2:
        this.digitalSignatureRequest.profilingSignature = event.signature;
        this.wizardComponent.nextStep();
        break;
      case 3:
        this.digitalSignatureRequest.dataSharingSignature = event.signature;
        this.wizardComponent.nextStep();
        break;
      case 4:
        this.sendSummaryMail = true;
        this.confirmCustomerConsent();
        break;
    }
  }

  onStepSkipped(event: { step: number }) {
    if (this.signatures[event.step]) {
      delete this.signatures[event.step];
    }
    switch (event.step) {
      case 1:
        this.digitalSignatureRequest.communicationSignature = null;
        this.wizardComponent.nextStep();
        break;
      case 2:
        this.digitalSignatureRequest.profilingSignature = null;
        this.wizardComponent.nextStep();
        break;
      case 3:
        this.digitalSignatureRequest.dataSharingSignature = null;
        this.checkAllStepsSkipped();
        break;
      case 4:
        this.sendSummaryMail = false;
        this.confirmCustomerConsent();
        break;
    }
  }

  checkAllStepsSkipped() {
    if (this.digitalSignatureRequest.communicationSignature === null &&
      this.digitalSignatureRequest.profilingSignature === null &&
      this.digitalSignatureRequest.dataSharingSignature === null) {
      this.wizardComponent.skipAllInProgress = true;
      this.sendSummaryMail = true;
      this.wizardComponent.noDigitalSignatures = true;
      this.confirmCustomerConsent();
    } else {
      this.wizardComponent.nextStep();
    }
  }

  confirmCustomerConsent() {
    this.wizardService
      .confirmCustomerConsentFromDigSigWizard(
        this.tecCustomerId,
        this.dealerId,
        this.interactionToken,
        this.sendSummaryMail,
        this.digitalSignatureRequest)
      .subscribe({
        next: (success) => {
          this.wizardComponent.skipAllInProgress = false;
          this.wizardComponent.confirmWithMailInProgress = false;
          this.wizardComponent.confirmWithoutMailInProgress = false;
          this.wizardComponent.goToTheLastStep();
        },
        error: error => {
          console.log('error by consent confirmation', error);
          this.redirectToErrorPage();
        }
      });
  }
}
